import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenuChecklists = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.66667 1.99996L11.3333 11.3333M6 1.99996V11.3333M3.33333 3.33329V11.3333M0.666666 0.666626V11.3333",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMenuChecklists;
